// export const selectList = [
// 	{
// 		placeholder: `Модель`,
// 		items: [
// 			{
// 				value: `iPhone 2`,
// 				title: ``
// 			},
// 			{
// 				value: `iPhone 15`,
// 				title: ``
// 			}
// 		]
// 	},
// 	{
// 		placeholder: `Год`,
// 		items: [
// 			{
// 				value: `iPhone 2`,
// 				title: ``
// 			},
// 			{
// 				value: `iPhone 15`,
// 				title: ``
// 			}
// 		]
// 	},
// 	{
// 		placeholder: `SSD`,
// 		items: [
// 			{
// 				value: `iPhone 2`,
// 				title: ``
// 			},
// 			{
// 				value: `iPhone 15`,
// 				title: ``
// 			}
// 		]
// 	},
// 	{
// 		placeholder: `Диагональ`,
// 		items: [
// 			{
// 				value: `iPhone 2`,
// 				title: ``
// 			},
// 			{
// 				value: `iPhone 15`,
// 				title: ``
// 			}
// 		]
// 	},
// 	{
// 		placeholder: `ОЗУ`,
// 		items: [
// 			{
// 				value: `iPhone 2`,
// 				title: ``
// 			},
// 			{
// 				value: `iPhone 15`,
// 				title: ``
// 			}
// 		]
// 	},
// 	{
// 		placeholder: `TouchFace`,
// 		items: [
// 			{
// 				value: `iPhone 2`,
// 				title: ``
// 			},
// 			{
// 				value: `iPhone 15`,
// 				title: ``
// 			}
// 		]
// 	}
// ]

export const heroInfoDataFiz = {
	imgSrc: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/trade-in/hero.png`,
	title: `Обмен в Трейд-ин`,
	subtitle: `Меняйтесь с лёгкостью. Сдайте своё устройство и получите выгоду в виде скидки на новое устройство или наличными на руки.`,
	items: [
		{
			title: `Мульти обмен в Трейд-ин`,
			description: `Можно сдавать неограниченное количество устройств.`
		},
		{
			title: `Легко и удобно`,
			description: `Быстрое оформление в наших магазинах.`
		},
		{
			title: `Онлайн-расчет
`,
			description: `Получи предварительную оценку на сайте.`
		}
	]
}

export const faqItemsFiz = [
	{
		question: `Что такое обмен в Трейд-ин? `,
		answer: `Обмен в Трейд-ин – это услуга по приёму старого устройства в счёт покупки нового.`
	},
	{
		question: `Как купить новое устройство с программой обмен в Трейд-ин?`,
		answer: `Вы можете оформить онлайн заказ с обменом в Трейд-ин на сайте iport.ru или
самовывозом, а также воспользоваться услугой в розничном магазине.`
	},
	{
		question: `Как подготовить iPhone к обмену в Трейд-ин?`,
		answer: `Чтобы подготовить устройство для использования в программе обмен в Трейд-ин,
необходимо отключить функцию «Найти мой iPhone».`
	},
	{
		question: `Как рассчитывается сумма по обмену в Трейд-ин?`,
		answer: `Сумма рассчитывается исходя из визуального и технического состояния устройства в момент его осмотра. Воспользоваться калькулятором цен можно на сайте iport.ru в разделе Обмен в Трейд-ин.
		<a href="https://cdn.iport.ru/iport/pdf/gradesTrade-in.pdf" type="file" target="_blank"> Информация о грейдах и визуальной оценке</a>`
	},
	{
		question: `Можно ли сдать в обмен в Трейд-ин два устройства?`,
		answer: `По программе обмен в Трейд-ин можно сдать неограниченное количество
устройств.`
	},
	{
		question: `Можно ли сдать нерабочий iPhone в обмен в Трейд-ин?`,
		answer: `По программе в обмен в Трейд-ин принимаются частично неработоспособные
устройства. Стоит учитывать, что стоимость такого устройства будет низкой. Сдать
устройство на оценку и получить подробную информацию о программе можно в
любом магазине iPort.`
	}
]

export const stepsList = [
	{
		title: `В магазине`,
		items: [
			{
				value: `Выберите новое устройство на сайте и оформите самовывоз, либо сразу обратитесь в магазин.`
			},
			{
				value: `Отдайте старое устройство нашему специалисту на диагностику.`
			},
			{
				value: `Используйте итоговую стоимость выкупа при покупке нового устройства. Можно в рассрочку.`
			}
		]
	}
]

export const pdfListFiz = [
	{
		title: ``,
		link: ``
	}
]

export const AdvLineData = {
	title: `iPort+`,
	subtitle: `Получите дополнительную выгоду до 30% на карту преимуществ iPort+ при условии сдачи своего устройства в обмен в Трейд-ин.
`,
	link: `/services/plus/`,
	buttonText: `Подробнее о карте iPort+`,
	image: {
		src: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/common/iport/iport-card.png`,
		width: 422,
		height: 263
	},
	withRedirectLink: true,
	redirectLink: `/services/plus/`,
	backgroundColor: `#D4E2FC`
}
